export default "__VITE_ASSET__DK_dOka0__"